import { render, staticRenderFns } from "./myActivity_detail.vue?vue&type=template&id=16e4a66e"
import script from "./myActivity_detail.vue?vue&type=script&lang=js"
export * from "./myActivity_detail.vue?vue&type=script&lang=js"
import style0 from "./myActivity_detail.vue?vue&type=style&index=0&id=16e4a66e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports